import React, { useState, useEffect } from "react";
import {
  Link,
  Toolbar,
  SaveButton,
  Button,
  Create,
  SimpleForm,
  FunctionField,
  DateField,
  Datagrid,
  TextField, TextInput,
  ReferenceField,
  DeleteButton,
  ReferenceManyField,
  TabbedForm,
  FormTab,
  DateInput,
  BooleanInput,
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
  Edit,
  EditButton,
  CREATE,
  GET_LIST,
  refreshView,
  showNotification
} from "react-admin";
import { connect } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button as MuiButton,
  TextField as MuiTextField,
  MenuItem
} from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import { isNil } from "ramda";
import styled from "styled-components";
import { TextBooleanField } from "../components/TextBooleanField";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import PostAddIcon from '@material-ui/icons/PostAdd';
import CopyTourButton from "./tours/copyTourButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Map from "@material-ui/icons/Map";
import { API_ROOT, BF_ROOT } from "../api-config";
import moment from "moment";
import { getPermissionRole } from "../util";
/* import Speed from "@material-ui/icons/Speed"; */

import momentTZ from 'moment-timezone';

const StyledA = styled.a`
  color: #ff9a00;
  font-weight: 400;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
`;
const StyledP = styled.p`
  color: red; 
`;
const StyledSpan = styled.div`
  color: red;
  padding: 10px;
  width: 100% !important;
`;

const TourTitle = object => (
  <span>
    {" Edit Tour - "} {object.record.id}
  </span>
);

const SpecialDeleteButton = object => {
  return (
    <DeleteButton
      record={object.record}
      // basepath={object.basePath}
      resource={object.resource}
      redirect={`/tours/${object.record.tour_id}/${object.option}`}
    />
  );
};
const AddKMBikeButton = object => {
  return (
    <Button
      component={Link}
      to={{
        pathname: `/unentered_km_tour_bikes/${object.record.id}`
      }}
      label="Add KM guide bike"
    >
    <PostAddIcon />
    </Button>
  );
};

const AddKMVansButton = object => {
  return (
    <Button
      component={Link}
      to={{
        pathname: `/unentered_km_tour_vans/${object.record.id}`
      }}
      label="Add KM vans"
    >
    <PostAddIcon />
    </Button>
  );
};

const tourCats = [
  { _id: 1, description: "Imt Tours" },
  { _id: 2, description: "Imt Custom Tours" },
  { _id: 3, description: "Globals Tours" }
];

const TourEditToolbar = (props, classes, className, disableSave) =>(
  <Toolbar {...props}>
    {([1, 2, 4, 6, 9].includes(getPermissionRole()) &&
      <React.Fragment>
        <SaveButton {...props} disabled={props.disableSave}/>
        <Button
          component={Link}
          to={{
            pathname: `/tour_prices/${props.record.id}`
          }}
          label="Tour Prices"
        >
          <ChatBubbleIcon />
        </Button>
      </React.Fragment>
    )}
    <CopyTourButton {...props} />
    <Button
      component={Link}
      to={{
        pathname: `/tour_prices`
      }}
      label="Back to Tour List"
    >
      <ArrowBackIcon />
    </Button>
    <Button
      component={Link}
      to={{
        pathname: `/tours`
      }}
      label="Back to Tour Whiteboard"
    >
      <Map />
    </Button>
  </Toolbar>
);

const AddSpecialMotorcycleButtonView = ({ record, refreshView, showNotification }) => {
  const [open, setOpen] = useState(false)
  const [models, setModels] = useState([])
  const [vehicleModelId, setVehicleModelId] = useState("")
  const [saving, setSaving] = useState(false)

  const close = () => {
    setOpen(false)
    setVehicleModelId("")
  }

  const openModal = async (event) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setOpen(true)
    const token = localStorage.getItem("token")
    const hiddenResponse = await fetch(`${API_ROOT}/vehicle_models/hidden?type=tours`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    const hidden = await hiddenResponse.json()
    const hiddenIds = hidden.tours || []
    if (hiddenIds.length === 0) {
      setModels([])
      return
    }
    const dataProvider = await dataProviderFactory("rest")
    const response = await dataProvider(GET_LIST, "vehicle_models", {
      filter: { id_like: hiddenIds.join("|") },
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "model_name", order: "ASC" }
    })
    setModels(response.data || [])
  }

  const save = async (event) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    if (!record || !record.id || !vehicleModelId) {
      showNotification("Model is required", "warning")
      return
    }
    setSaving(true)
    try {
      const dataProvider = await dataProviderFactory("rest")
      await dataProvider(CREATE, "tour_special_motorcycles", {
        data: {
          tour_id: record.id,
          vehicle_model_id: Number(vehicleModelId),
          enabled: true
        }
      })
      showNotification("Special motorcycle added", "info")
      close()
      refreshView()
    } catch (error) {
      showNotification("Could not add this motorcycle", "warning")
    }
    setSaving(false)
  }

  return (
    <React.Fragment>
      <Button type="button" label="Add special motorcycle" onClick={openModal}>
        <ChatBubbleIcon />
      </Button>
      <Dialog open={open} onClose={close} fullWidth maxWidth="sm">
        <DialogTitle>Add special motorcycle</DialogTitle>
        <DialogContent>
          <MuiTextField
            select
            fullWidth
            label="Model"
            value={vehicleModelId}
            onChange={(event) => setVehicleModelId(event.target.value)}
            margin="normal"
          >
            {models.map((model) => (
              <MenuItem key={model.id} value={model.id}>
                {model.model_name}
              </MenuItem>
            ))}
          </MuiTextField>
        </DialogContent>
        <DialogActions>
          <MuiButton type="button" onClick={close} disabled={saving}>Cancel</MuiButton>
          <MuiButton type="button" onClick={save} color="primary" disabled={saving}>Save</MuiButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

const AddSpecialMotorcycleButton = connect(null, { refreshView, showNotification })(AddSpecialMotorcycleButtonView)

const AddNewTourGuideButton = object => {
  return (
    <Button
      component={Link}
      to={{
        pathname: "/tour_guides/create",
        search: `?tour_id=${object.record.id}`
      }}
      label="Add tour guide"
    >
      <ChatBubbleIcon />
    </Button>
  );
};

const AddNewTourGpsDeviceButton = object => {
  return (
    <Button
      component={Link}
      to={{
        pathname: "/tour_gps_devices/create",
        search: `?tour_id=${object.record.id}`
      }}
      label="Add tour gps device"
    >
      <ChatBubbleIcon />
    </Button>
  );
};

const AddNewBikeButton = object => {
  return (
    <Button
      component={Link}
      to={{
        pathname: "/tour_bikes/create",
        search: `?tour_id=${object.record.id}`
      }}
      label="Add tour guide bike"
    >
      <ChatBubbleIcon />
    </Button>
  );
};

const AddNewVanButton = object => {
  return (
    <Button
      component={Link}
      to={{
        pathname: "/tour_vans/create",
        search: `?tour_id=${object.record.id}`
      }}
      label="Add tour guide van"
    >
      <ChatBubbleIcon />
    </Button>
  );
};

const AddNewTourVanPassengerButton = object => {
  if (object.record.tour_with_van) {
    return (
      <Button
        component={Link}
        to={{
          pathname: "/van_passengers/create",
          search: `?tour_id=${object.record.id}`
        }}
        label="Add tour van passenger"
      >
        <ChatBubbleIcon />
      </Button>
    );
  } else {
    return (
      <p>
        <span>No van assigned to tour</span>
      </p>
    );
  }
};

const CustomEditTourVanPassengerButton = ({ record = {} }) => {
  return (
    <EditButton
      to={{
        pathname: `/van_passengers/${record.id}`,
        search: `?tour_id=${record.tour_id}`
      }}
      label="Edit Tour Van Passenger"
    />
  );
};

const VanPassengers = props => {
  return (
    <FormTab label="Tour Van Passengers" {...props}>
      <ReferenceManyField
        addLabel={false}
        reference="van_passengers"
        target="tour_id"
      >
        <Datagrid>
          <TextField source="id" label="Id" />
          <ReferenceField
            label="Client Full Name"
            source="client_id"
            reference="clients"
            linkType={false}
          >
            <FunctionField
              render={client =>
                `${client.client_first_name} ${client.client_last_name}`
              }
            />
          </ReferenceField>
          <CustomEditTourVanPassengerButton />
        </Datagrid>
      </ReferenceManyField>
      {([1, 2, 4, 6, 9].includes(getPermissionRole()) &&
      <AddNewTourVanPassengerButton />
      )}
    </FormTab>
  );
};

const TourGuides = props => {
  return (
    <FormTab label="Tour Guides" {...props}>
      <ReferenceManyField
        addLabel={false}
        reference="tour_guides"
        target="tour_id"
        linkType={false}
      >
        <Datagrid>
          <FunctionField
            render={r => {
              
            }}
          />
          <TextField source="id" />
          <ReferenceField
            label="Guide Name"
            source="guide_id"
            reference="guides"
            linkType={false}
          >
            <TextField source="name" />
          </ReferenceField>
          <TextBooleanField source="briefing_guide" />
          {([1, 2, 4, 6, 9].includes(getPermissionRole()) &&
            <SpecialDeleteButton option={4} />
          )}
        </Datagrid>
      </ReferenceManyField>
      {([1, 2, 4, 6, 9].includes(getPermissionRole()) &&
        <AddNewTourGuideButton />      
      )}
    </FormTab>
  );
};

const TourBikes = props => {
  return (
    <FormTab label="Tour Bikes" {...props}>
      <ReferenceManyField
        addLabel={false}
        reference="tour_bikes"
        target="tour_id"
        linkType={false}
      >
        <Datagrid>
          <ReferenceField
            label="Vehicle"
            source="vehicle_id"
            reference="vehicles"
            filter={{ vehicle_type_id: "1" }}
            linkType={false}
          >
            <FunctionField
              render={vehicle => {
                if (vehicle.model === undefined) {
                }
                const modelName = isNil(vehicle.model)
                  ? ""
                  : `- ${vehicle.model.model_name}`;

                return ` ${vehicle.licence_plate} ${vehicle.renting ? "®" : ""} ${modelName}`;
              }}
            />
          </ReferenceField>
          <SpecialDeleteButton option={5} />
          <AddKMBikeButton />
        </Datagrid>
      </ReferenceManyField>
      {([1, 2, 4, 6, 9].includes(getPermissionRole()) && 
        <AddNewBikeButton />
      )}
    </FormTab>
  );
};

const TourVans = props => {
  return (
    <FormTab label="Tour Vans" {...props}>
      <ReferenceManyField
        addLabel={false}
        reference="tour_vans"
        target="tour_id"
        linkType={false}
      >
        <Datagrid>
          <TextField source="id" />
          <ReferenceField
            label="Vehicle"
            source="vehicle_id"
            reference="vehicles"
            linkType={false}
          >
            <FunctionField
              render={vehicle => {
                if (vehicle.model === undefined) {
                }
                const modelName = isNil(vehicle.model)
                  ? ""
                  : `- ${vehicle.model.model_name}`;

                return ` ${vehicle.licence_plate} ${vehicle.renting ? "®" : ""} ${modelName}`;
              }}
            />
          </ReferenceField>
          <SpecialDeleteButton option={6} />
          <AddKMVansButton />
        </Datagrid>
      </ReferenceManyField>
      {([1, 2, 4, 6, 9].includes(getPermissionRole()) &&
       <AddNewVanButton />
      )}
    </FormTab>
  );
};

const TourGpsDevices = props => {
  return (
    <FormTab label="Tour GPS" {...props}>
      <ReferenceManyField
        addLabel={false}
        reference="tour_gps_devices"
        target="tour_id"
        linkType={false}
      >
        <Datagrid>
          <TextField source="id" />
          <ReferenceField
            label="GPS"
            source="gps_device_id"
            reference="gps_devices"
            linkType={false}
          >
            <FunctionField
              render={gps => {
                return ` ${gps.id} - ${gps.model}`;
              }}
            />
          </ReferenceField>
          <SpecialDeleteButton option={7} />
        </Datagrid>
      </ReferenceManyField>
      {([1, 2, 4, 6, 9].includes(getPermissionRole()) && 
        <AddNewTourGpsDeviceButton /> 
      )}
    </FormTab>
  );
};

const TourCreateToolbar = (props, classes, className) => (
  <Toolbar {...props}>
    {( [1, 2, 4, 6, 9].includes(getPermissionRole()) &&
      <SaveButton />
    )}

    <Button
      component={Link}
      to={{
        pathname: `/tour_prices`
      }}
      label="Back to Tour List"
    >
      <ArrowBackIcon />
    </Button>
    <Button
      component={Link}
      to={{
        pathname: `/tours`
      }}
      label="Back to Tour Whiteboard"
    >
      <Map />
    </Button>
  </Toolbar>
);

function handleChange(element, type) {
  if (element.target.id === "tour_start_date") {
    //console.log('se cambio')
    const newDate2 = moment(element.target.value).add(1, 'day').format("YYYY-MM-DD")
    const date2 = document.getElementById('tour_end_date')
    date2.min = element.target.value
    const date3 = document.getElementById('effective_start_date')
    date3.min = element.target.value
    date2.value = newDate2
  }
  if (element.target.id === "effective_start_date") {
    //console.log('se cambio')
    const newDate2 = moment(element.target.value).add(1, 'day').format("YYYY-MM-DD")
    const date2 = document.getElementById('effective_end_date')
    date2.min = element.target.value
    date2.value = newDate2
  }
}

/* const [tour_status, setTour_status] = useState(false);
function handleClickStatus() { 
      if (isNil(clientTour)) {
        console.log('no tiene cliente') 
       // boleanInput.value = false
        statusTour = false
        console.log('%ctours.js line:516 statusTour', 'color: #007acc;', statusTour);
        
        setTour_status(false)
        return statusTour
      }
      else{
        console.log('tiene cliente')
        //boleanInput.value = true  
        statusTour = true
        console.log('%ctours.js line:516 statusTour', 'color: #007acc;', statusTour);
        setTour_status(true)
        return statusTour
      }  

} */

export const TourCreate = props => (
  <Create title="Create" {...props}>
    <SimpleForm
      redirect="edit"
      toolbar={<TourCreateToolbar props={{ ...props }} />}
    >
      {/* <DateInput label="Start Date" source="tour_start_date" /> */}
      <TextInput id="tour_start_date" locales="es-Es" 
        label="Start Date" type="date" name="tour_start_date" source="tour_start_date"
        onChange={e => handleChange(e, "tour_start_date")}  options={{ timeZone: 'UTC' }}
        defaultValue={moment(null).format("YYYY-MM-DD")}
        InputLabelProps={{ shrink: true }}
      />
      <TextInput id="tour_end_date" locales="es-Es" 
        label="End Date" type="date" name="tour_end_date" source="tour_end_date"
        defaultValue={moment(null).format("YYYY-MM-DD")}  options={{ timeZone: 'UTC' }}
        InputLabelProps={{ shrink: true }}
      />
      {/* <DateInput label="End Date" source="tour_end_date" /> */}
      {/* <DateInput label="Effective Start Date" source="effective_start_date" /> */}
      <TextInput id="effective_start_date" locales="es-Es" 
        label="Effective Start Date" type="date" name="effective_start_date" source="effective_start_date"
        onChange={e => handleChange(e, "effective_start_date")} 
        defaultValue={moment(null).format("YYYY-MM-DD")} options={{ timeZone: 'UTC' }} 
        InputLabelProps={{ shrink: true }}
      />
      <DateInput label="Effective End Date" locales="es-Es" 
       options={{ timeZone: 'UTC' }} 
       source="effective_end_date" />
      <ReferenceInput
        label="Tour Name"
        source="tour_name_id"
        reference="tour_names"
        sort={{ field: "tour_name_en", order: "ASC" }}
      >
        <AutocompleteInput source="id" optionText="tour_name_en" />
      </ReferenceInput>
      <SelectInput
        source="tour_category_id"
        choices={tourCats}
        optionText="description"
        optionValue="_id"
      />
      <ReferenceInput
        label="Tour begin location"
        source="location_id_1"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <SelectInput source="id" optionText="location_name" />
      </ReferenceInput>
      <ReferenceInput
        label="Tour end location"
        source="location_id_2"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <SelectInput source="id" optionText="location_name" />
      </ReferenceInput>
      <BooleanInput source="tour_status" label="Tour Active" />
      <BooleanInput source="self_guided" label="Self Guided" />

      <BooleanInput source="mode_tour" label="Is passions" />

      {/* <BooleanInput source="ride_end" label="Ride End" /> */}
    </SimpleForm>
  </Create>
);

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

let clientTour, statusTour, tourHasClient = false


export const TourEdit = (props) => {  
  const [tour_status, setTour_status] = useState(false);
  const [tourRecord, setTourRecord] = useState(props)
  const [disableSave, setDisableSave] = useState(false)

  useEffect(() => {
    clientTour = false
  }, [props.id])
  
  function handleClickStatus() { 
      if (isNil(clientTour) || clientTour == undefined) {
        statusTour = false
        setTour_status(false)
        return statusTour
      }
      else{
        statusTour = true
        setTour_status(true)
        return statusTour
      }  
  }


  const handleChangeDate = (event) =>{
    compareDates(event)
  }


  const compareDates = (event) =>{
    const { name, value } = event.target;
    if(!isNil(clientTour) && clientTour !== undefined && clientTour !== false){
      if(moment(value).isSame(moment(Fecha(tourRecord[name])))){
        setDisableSave(false)
      }else{
        setDisableSave(true)
      }
    }
  } 


  const updateTourRecord = (record) => {
    setTourRecord(record);
  };


  return (
  <Edit title={<TourTitle />} {...props}>
    <TabbedForm
      toolbar={<TourEditToolbar disableSave={disableSave} props={{ ...props }}  />}
      redirect="edit"
    >
        
      <FormTab label="General Data" props={{ ...props }} >
        <FunctionField
          addLabel={false}
          render={props => {
            if(props.id){updateTourRecord(props)}
          }}
        />
        {disableSave && (
          <StyledSpan>
            * you cannot change the dates if there are registered customers
          </StyledSpan>
        )}
        <TextInput source='tour_start_date' name="tour_start_date" type="date"
          locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha}
          label="Start Date" onChange={e => handleChangeDate(e)}
        />
        <TextInput locales="es-Es"
          options={{ timeZone: 'UTC' }}
          format={Fecha}
          label="End Date"
          source="tour_end_date"
          name="tour_end_date"
          onChange={e => handleChangeDate(e)}
          type="date" />
        <TextInput locales="es-Es" label="Effective Start Date"
          options={{ timeZone: 'UTC' }}
          format={Fecha}
          source="effective_start_date"
          name="effective_start_date"
          onChange={e => handleChangeDate(e)}
          type="date" />
        <TextInput locales="es-Es" label="Effective End Date"
          options={{ timeZone: 'UTC' }}
          format={Fecha}
          source="effective_end_date"
          name="effective_end_date"
          onChange={e => handleChangeDate(e)}
          type="date" />
        <ReferenceInput
          label="Tour Name"
          source="tour_name_id"
          reference="tour_names"
          sort={{ field: "tour_name_en", order: "ASC" }}
        >
          <AutocompleteInput
            source="id"
            optionText="tour_name_en"
            perPage={1000}
          />
        </ReferenceInput>
        <SelectInput
          source="tour_category_id"
          choices={tourCats}
          optionText="description"
          optionValue="_id"
        />
        <ReferenceInput
          label="Tour begin location"
          source="location_id_1"
          reference="locations"
          filter={{ only_bases: "true" }}
          sort={{ field: "location_name", order: "ASC" }}
        >
          <SelectInput source="id" optionText="location_name" />
        </ReferenceInput>
        <ReferenceInput
          label="Tour end location"
          source="location_id_2"
          reference="locations"
          filter={{ only_bases: "true" }}
          sort={{ field: "location_name", order: "ASC" }}
        >
          <SelectInput source="id" optionText="location_name" />
        </ReferenceInput>
        <BooleanInput source="tour_status" defaultValue={tour_status} value={tour_status} onClick={handleClickStatus} onchange={handleClickStatus} label="Tour Active" />
        {tour_status == true && (
            <React.Fragment> 
              <StyledP>The tour has assigned clients, check the tour clients.</StyledP>
            </React.Fragment>
        )}
       <BooleanInput source="self_guided" label="Self Guided" /> 

       <BooleanInput source="mode_tour" label="Is passions" />
       
        {/* <BooleanInput source="ride_end" label="Ride End" /> */}
        <br />
        <br />
        <FunctionField
          style={{ width: "100%", textAlign: "left" }}
          label="TOUR LINKS"
          render={tour => {
            return (
              <React.Fragment>
                <p>{`${BF_ROOT}/tour_booking?tourUid=${tour.tour_uid}&locale=en`}</p>
                <StyledA
                  target="_blank"
                  href={`${BF_ROOT}/tour_booking?tourUid=${tour.tour_uid}&locale=en`}
                >
                  Direct link EN
                </StyledA>
                <br />
                <p>{`${BF_ROOT}/tour_booking?tourUid=${tour.tour_uid}&locale=es`}</p>
                <StyledA
                  target="_blank"
                  href={`${BF_ROOT}/tour_booking?tourUid=${tour.tour_uid}&locale=es`}
                >
                  Direct link ES
                </StyledA>
                <br />
                <p>{`${BF_ROOT}/tour_booking?tourUid=${tour.tour_uid}&locale=de`}</p>
                <StyledA
                  target="_blank"
                  href={`${BF_ROOT}/tour_booking?tourUid=${tour.tour_uid}&locale=de`}
                >
                  Direct link DE
                </StyledA>
                <br />
                <p>{`${BF_ROOT}/tour_booking?tourUid=${tour.tour_uid}&locale=pt`}</p>
                <StyledA
                  target="_blank"
                  href={`${BF_ROOT}/tour_booking?tourUid=${tour.tour_uid}&locale=pt`}
                >
                  Direct link PT
                </StyledA>
              </React.Fragment>
            );
          }}
        />
        <br />
        <br />
        <FunctionField
          style={{ width: "100%", textAlign: "left" }}
          label="TOUR LINKS P4M"
          render={tour => {
            return (
              <React.Fragment>
                <p>{`${BF_ROOT}/tour_booking?tourUid=${tour.tour_uid}&p4m=1&locale=en`}</p>
                <StyledA
                  target="_blank"
                  href={`${BF_ROOT}/tour_booking?tourUid=${tour.tour_uid}&p4m=1&locale=en`}
                >
                  Direct link P4M EN
                </StyledA>
                <br />

                <p>{`${BF_ROOT}/tour_booking?tourUid=${tour.tour_uid}&p4m=1&locale=es`}</p>
                <StyledA
                  target="_blank"
                  href={`${BF_ROOT}/tour_booking?tourUid=${tour.tour_uid}&p4m=1&locale=es`}
                >
                  Direct link P4M ES
                </StyledA>
                <br />

                <p>{`${BF_ROOT}/tour_booking?tourUid=${tour.tour_uid}&p4m=1&locale=de`}</p>
                <StyledA
                  target="_blank"
                  href={`${BF_ROOT}/tour_booking?tourUid=${tour.tour_uid}&p4m=1&locale=de`}
                >
                  Direct link P4M DE
                </StyledA>
                <br />

                <p>{`${BF_ROOT}/tour_booking?tourUid=${tour.tour_uid}&p4m=1&locale=pt`}</p>
                <StyledA
                  target="_blank"
                  href={`${BF_ROOT}/tour_booking?tourUid=${tour.tour_uid}&p4m=1&locale=pt`}
                >
                  Direct link P4M PT
                </StyledA>
                <br />
              </React.Fragment>
            );
          }}
        />
      </FormTab>

      <FormTab label="Tour Clients">
        <ReferenceManyField
          addLabel={false}
          reference="tour_clients"
          target="tour_id"
          sort={{ field: "r_timestamp", order: "ASC" }}
        >
          <Datagrid>
            <TextField source="id" label="Client Id" />
            <TextField source="booking_id" label="Booking Id" />
            <DateField source="r_timestamp" label="Booking Date" />

            <FunctionField
              label="Type"
              render={item => `${item.is_passenger ? "Passenger" : "Driver"}`}
            />

            <ReferenceField label="Name" source="booking_id" reference="bookings" linkType={false}>
              <FunctionField
                render={booking => {
                  clientTour = booking
                  return (
                    <Link
                      to={{ pathname: `/clients/${booking.client_id}` }}
                      target="_blank"
                    >{`${booking.r_first_name} ${booking.r_last_name}`}</Link>
                  );
                }
                }
              />
            </ReferenceField>
            <ReferenceField
              label="Address"
              source="client_id"
              reference="clients"
              linkType={false}
            >
              <TextField source="client_address" label="Address" />
            </ReferenceField>
            <ReferenceField
              label="City"
              source="client_id"
              reference="clients"
              linkType={false}
            >
              <TextField source="client_city" label="Address" />
            </ReferenceField>
            <ReferenceField
              label="Country"
              source="client_id"
              reference="clients"
              linkType={false}
            >
              <ReferenceField
                source="country_id"
                reference="countries"
                linkType={false}
              >
                <TextField source="country" />
              </ReferenceField>
            </ReferenceField>
          </Datagrid>
        </ReferenceManyField>
      </FormTab>
      <FormTab label="Special Motorcycles" {...props}>
        <ReferenceManyField
          addLabel={false}
          reference="tour_special_motorcycles"
          target="tour_id"
          linkType={false}
        >
          <Datagrid>
            <TextField source="tour_id" label="Tour" />
            <TextField source="vehicle_model_id" label="Model id" />
            <ReferenceField
              label="Model"
              source="vehicle_model_id"
              reference="vehicle_models"
              linkType={false}
            >
              <TextField source="model_name" />
            </ReferenceField>
            <ReferenceField
              label="Upgrade type"
              source="vehicle_model_id"
              reference="vehicle_models"
              linkType={false}
            >
              <TextField source="upgrade_type" />
            </ReferenceField>
            <TextBooleanField source="enabled" label="Enabled" />
            <SpecialDeleteButton option={2} />
          </Datagrid>
        </ReferenceManyField>
        <AddSpecialMotorcycleButton />
      </FormTab>
      <VanPassengers {...props} />
      <TourGuides {...props} />
      <TourBikes {...props} />
      <TourVans {...props} />
      <TourGpsDevices {...props} />
    </TabbedForm>
  </Edit>
)};



// WEBPACK FOOTER //
// ./src/resources/tours.js